import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M18.259 7.979c.15.143.155.38.012.53l-7.875 8.25a.375.375 0 0 1-.536.006L5.735 12.64a.375.375 0 0 1 .53-.53l3.854 3.853 7.61-7.972a.375.375 0 0 1 .53-.012",
		clipRule: "evenodd"
	})
});
export default SvgCheck;
